// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__HOIRK","box":"Footer_box__OcXAr","logo":"Footer_logo__5k-PN","hoverItem":"Footer_hoverItem__H0ryn","bottom":"Footer_bottom__WTj0k"};